import IconPlusSolid from '@/assets/icons/font_awesome/plus-solid.svg?react';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_separator } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_separator';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { toast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { remote_workspace_create } from '@/state/workspace/entity/remote_workspace_create';
import { set_current_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { RefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  ref_dropdown_item_workspace: RefObject<HTMLDivElement>;
}

export const ButtonWorkspaceCreate = ({ ref_dropdown_item_workspace }: Props) => {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const dispatch = use_dispatch();

  const { user_id } = use_slice_user(['user_id']);
  const { workspaces_map } = use_slice_workspace(['workspaces_map']);
  const { user_settings } = use_slice_user(['user_settings']);

  const [is_loading, set_is_loading] = useState(false);
  const [is_hovered, set_is_hovered] = useState(false);

  let users_own_workspaces = Array.from(workspaces_map.values()).filter(item => item.user_id_owner == user_id);

  /*
   * EVENTS
   */
  async function on_item_selected() {
    set_is_loading(true);
    const action_result = await dispatch(remote_workspace_create());
    set_is_loading(false);

    if (typeof action_result.payload != 'string') return;

    const workspace_id = action_result.payload;
    const settings_new = user_settings.clone({ default_workspace_id: workspace_id });
    await dispatch(REMOTE__user_settings_update(settings_new));

    if (ref_dropdown_item_workspace.current) {
      ref_dropdown_item_workspace.current.scrollIntoView({ behavior: 'smooth' });
    }

    toast({ title: t(i18n_base_ui.toasts.update_default_workspace.title) });

    set_current_workspace(workspace_id);
  }

  /*
   * HTML
   */

  if (users_own_workspaces.length >= CONSTANTS__shared.WORKSPACE_LIMIT_PER_USER) return <></>;

  return (
    <>
      <UI_PRIMITIVE__dropdown_menu_separator />

      <UI_PRIMITIVE__dropdown_menu_item
        onMouseEnter={() => set_is_hovered(true)}
        onMouseLeave={() => set_is_hovered(false)}
        value=""
        disabled={is_loading}
        className={`gap-2 p-2 cursor-pointer ${is_hovered ? 'bg-component' : 'bg-background'}`}
        {...{ on_item_selected }}
      >
        <div
          className={`flex size-8 min-w-8 items-center justify-center rounded-md border border-component-item bg-background 
            ${is_hovered ? 'bg-component' : 'bg-background'} hover:bg-background`}
        >
          <IconPlusSolid className="!text-component-item-foreground size-3" />
        </div>
        <div className="font-medium text-muted-foreground">{t(i18n_base_ui.sidebar_navigation.workspaces.button.create.title)}</div>
      </UI_PRIMITIVE__dropdown_menu_item>
    </>
  );
};
